
export class SystemStatusResult{

    constructor(public iotHub: string,
        public systemGuid: string,
        public systemStatus: string) {
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/sentienceDeviceManager/system-status-result.ts
 **/